package com.eladfinish.bible.contest.screens.main.data

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.StrokeJoin
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathParser
import androidx.compose.ui.unit.dp

/**
 * Custom "random verse" icon: an open book (the Tanakh) with sparkles above it —
 * a verse that shines / is revealed at random from scripture. The icon is tinted at
 * render time, so the colors here are irrelevant.
 */
val RandomVerseIcon: ImageVector by lazy {
    fun nodes(pathData: String) = PathParser().parsePathString(pathData).toNodes()
    val tint = SolidColor(Color.Black)
    ImageVector.Builder(
        name = "RandomVerse",
        defaultWidth = 24.dp,
        defaultHeight = 24.dp,
        viewportWidth = 24f,
        viewportHeight = 24f,
    ).apply {
        addPath(
            pathData = nodes(BOOK_PATH),
            stroke = tint,
            strokeLineWidth = 1.4f,
            strokeLineJoin = StrokeJoin.Round,
            strokeLineCap = StrokeCap.Round,
        )
        addPath(
            pathData = nodes(SPINE_PATH),
            stroke = tint,
            strokeLineWidth = 1.4f,
            strokeLineCap = StrokeCap.Round,
        )
        addPath(pathData = nodes(SPARKLE_PATH), fill = tint)
    }.build()
}

private const val BOOK_PATH =
    "M2.5 10.7 C 6 9.5, 9.5 9.5, 12 11.1 C 14.5 9.5, 18 9.5, 21.5 10.7 L 21.5 19.5 " +
        "C 18 18.3, 14.5 18.3, 12 19.9 C 9.5 18.3, 6 18.3, 2.5 19.5 Z"

private const val SPINE_PATH = "M12 11.1 L12 19.9"

private const val SPARKLE_PATH =
    "M10 0.8 C 10.3 3.0, 11.0 3.9, 13.4 4.2 C 11.0 4.5, 10.3 5.4, 10 7.6 " +
        "C 9.7 5.4, 9.0 4.5, 6.6 4.2 C 9.0 3.9, 9.7 3.0, 10 0.8 Z " +
        "M16.4 3.0 C 16.5 4.0, 16.8 4.4, 17.9 4.6 C 16.8 4.8, 16.5 5.2, 16.4 6.2 " +
        "C 16.3 5.2, 16.0 4.8, 14.9 4.6 C 16.0 4.4, 16.3 4.0, 16.4 3.0 Z"
